import { render, staticRenderFns } from "./ProfileRight.vue?vue&type=template&id=7035482c&scoped=true"
import script from "./ProfileRight.vue?vue&type=script&lang=ts"
export * from "./ProfileRight.vue?vue&type=script&lang=ts"
import style0 from "./ProfileRight.vue?vue&type=style&index=0&id=7035482c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7035482c",
  null
  
)

export default component.exports